module.exports = __webpack_public_path__ + "static/media/releaseNotes.e38aff36.md";